export default function () {
  return useState('referrer', () => (process.server ? useRequestHeaders().referer : document.location.referrer))
}
